import { pdfjs } from 'react-pdf';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { useResizeObserver } from '@wojtekmaj/react-hooks';

import { Button, Col, Modal, Row, Space } from 'antd';
import styled from 'styled-components';
import { useCallback, useState } from 'react';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const StyledDiv = styled.div`
  body {
    margin: 0;
    background-color: #525659;
    font-family: Segoe UI, Tahoma, sans-serif;
  }

  .Example input,
  .Example button {
    font: inherit;
  }

  .Example header {
    background-color: #323639;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    padding: 20px;
    color: white;
  }

  .Example header h1 {
    font-size: inherit;
    margin: 0;
  }

  .Example__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px 0;
    padding: 10px;
  }

  .Example__container__load {
    margin-top: 1em;
    color: white;
  }

  .Example__container__document {
    width: 100%;
    max-width: calc(100% - 2em);
    margin: 1em 0;
  }

  .Example__container__document .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .Example__container__document .react-pdf__Page {
    margin: 1em 0;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
  }

  .Example__container__document .react-pdf__message {
    padding: 20px;
    color: white;
  }
`;

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

const resizeObserverOptions = {};

const maxWidth = 800;

interface PDFViewModal2Props {
  visible: boolean;
  url: string;
  onCancel: () => void;
  onDownload: () => void;
}

function PDFViewModal2({
  visible,
  url,
  onCancel,
  onDownload,
}: PDFViewModal2Props) {
  const [numPages, setNumPages] = useState<number>();
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>();

  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries;

    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  useResizeObserver(containerRef, resizeObserverOptions, onResize);

  // function onFileChange(event: React.ChangeEvent<HTMLInputElement>): void {
  //   const { files } = event.target;

  //   if (files && files[0]) {
  //     setFile(files[0] || null);
  //   }
  // }

  // function onDocumentLoadSuccess({
  //   numPages: nextNumPages,
  // }: PDFDocumentProxy): void {
  //   setNumPages(nextNumPages);
  // }

  // const [numPages, setNumPages] = useState<number>(0);
  // const [pageNumber, setPageNumber] = useState<number>(1);

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
    // setPageNumber(1);
  }

  // function changePage(offset: any) {
  //   setPageNumber((prevPageNumber) => prevPageNumber + offset);
  // }

  // function previousPage() {
  //   changePage(-1);
  // }

  // function nextPage() {
  //   changePage(1);
  // }

  return (
    <>
      <Modal
        open={visible}
        title="첨부파일 보기"
        footer={null}
        onCancel={onCancel}
        width={800}
      >
        <StyledDiv>
          <div className="Example">
            <div className="Example__container">
              {/* <Row justify="center">
          <Col span={24}> */}
              <div
                className="Example__container__document"
                ref={setContainerRef}
              >
                <Document
                  file={`${url}`}
                  onLoadSuccess={onDocumentLoadSuccess}
                  options={options}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      width={
                        containerWidth
                          ? Math.min(containerWidth, maxWidth)
                          : maxWidth
                      }
                    />
                  ))}
                </Document>
              </div>
            </div>
          </div>
        </StyledDiv>

        {/* <Document
              file={`${data.file[0].url}`}
              onLoadSuccess={onDocumentLoadSuccess}
              // rotate={270}
            >
              <Page pageNumber={pageNumber} width={800} />
              <div>
                <p>
                  Page {pageNumber || (numPages ? 1 : '--')} of{' '}
                  {numPages || '--'}
                </p>
                <button
                  type="button"
                  disabled={pageNumber <= 1}
                  onClick={previousPage}
                >
                  Previous
                </button>
                <button
                  type="button"
                  disabled={pageNumber >= numPages}
                  onClick={nextPage}
                >
                  Next
                </button>
              </div>
            </Document> */}
        {/* </Col>
        </Row> */}
        <Row justify="center">
          <Col>
            <Space>
              <Button onClick={onDownload}>다운로드</Button>
              <Button onClick={onCancel}>닫기</Button>
            </Space>
          </Col>
        </Row>
      </Modal>
    </>
  );
}

export default PDFViewModal2;
